import * as React from "react";
import styles from "./HeaderProducts.module.css";
import { Box, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function HeaderProducts() {
  const [selection, setSelection] = useState(0);

  const handleChange = (event, newValue) => {
    setSelection(newValue);
  };

  return (
    <Box className={styles.top}>
      <Box
        sx={{
          width: "300px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className={styles.box}
      >
        <p
          style={{
            marginRight: "10px",
            fontSize: "18px",
            color: "#333",
            fontWeight: 540,
          }}
        >
          Category
        </p>
        <Select
          value={selection}
          onChange={handleChange}
          displayEmpty
          // Use renderValue to show placeholder text when value is empty
          renderValue={(selected) => {
            if (selected === 0) {
              return <MenuItem value={0}>All</MenuItem>; // Placeholder text
            }
            return selected;
          }}
          sx={{
            width: "180px",
            margin: ".4rem",
            padding: "1.5px",
            border: "none",
            color: "#000 ",
            bgcolor: "#eff1f1",
            "& .MuiSelect-select": {
              padding: 0,
            },
          }}
          IconComponent={(props) => (
            <ExpandMoreIcon {...props} style={{ color: "black" }} />
          )}
        >
          <MenuItem value={0}>All</MenuItem>
          <MenuItem value={1}>Open Tickets</MenuItem>
          <MenuItem value={2}>Pending Tickets</MenuItem>
          <MenuItem value={3}>Resolved Tickets</MenuItem>
          <MenuItem value={4}>Closed Tickets</MenuItem>
        </Select>
      </Box>
      <Box
        sx={{
          width: "300px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className={styles.box}
      >
        <p
          style={{
            marginRight: "10px",
            fontSize: "18px",
            color: "#333",
            fontWeight: 540,
          }}
        >
          Product Type
        </p>
        <Select
          value={selection}
          onChange={handleChange}
          displayEmpty
          // Use renderValue to show placeholder text when value is empty
          renderValue={(selected) => {
            if (selected === 0) {
              return <MenuItem value={0}>All</MenuItem>; // Placeholder text
            }
            return selected;
          }}
          sx={{
            width: "180px",
            margin: ".4rem",
            padding: "1.5px",
            border: "none",
            color: "#000 ",
            bgcolor: "#eff1f1",
            "& .MuiSelect-select": {
              padding: 0,
            },
          }}
          IconComponent={(props) => (
            <ExpandMoreIcon {...props} style={{ color: "black" }} />
          )}
        >
          <MenuItem value={0}>All</MenuItem>
          <MenuItem value={1}>Open Tickets</MenuItem>
          <MenuItem value={2}>Pending Tickets</MenuItem>
          <MenuItem value={3}>Resolved Tickets</MenuItem>
          <MenuItem value={4}>Closed Tickets</MenuItem>
        </Select>
      </Box>
      <Box
        sx={{
          width: "300px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className={styles.box}
      >
        <p
          style={{
            marginRight: "10px",
            fontSize: "18px",
            color: "#333",
            fontWeight: 540,
          }}
        >
          Employee
        </p>
        <Select
          value={selection}
          onChange={handleChange}
          displayEmpty
          // Use renderValue to show placeholder text when value is empty
          renderValue={(selected) => {
            if (selected === 0) {
              return <MenuItem value={0}>All</MenuItem>; // Placeholder text
            }
            return selected;
          }}
          sx={{
            width: "180px",
            margin: ".4rem",
            padding: "1.5px",
            border: "none",
            color: "#000 ",
            bgcolor: "#eff1f1",
            "& .MuiSelect-select": {
              padding: 0,
            },
          }}
          IconComponent={(props) => (
            <ExpandMoreIcon {...props} style={{ color: "black" }} />
          )}
        >
          <MenuItem value={0}>All</MenuItem>
          <MenuItem value={1}>Open Tickets</MenuItem>
          <MenuItem value={2}>Pending Tickets</MenuItem>
          <MenuItem value={3}>Resolved Tickets</MenuItem>
          <MenuItem value={4}>Closed Tickets</MenuItem>
        </Select>
      </Box>
    </Box>
  );
}
